// ✅ general.js – Stealth traps (hardened, no filename exposure)
(function () {
  'use strict';
  console.log('[🧠 Security traps active]');

  var config = {
    reportEndpoint: 'https://api.padronn.com/api/bot-report',
    cookieName: 'vdg_verified',
    localFlag: 'vdg_fingerprint',
    suspicionThreshold: 3,
    allowGraceOnMobile: true,
    delayBeforeCheckMs: 15000,
    trustedIps: ['91.140.27.123', '116.203.76.94']
  };

  var state = {
    suspicionScore: 0,
    isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
    traps: {
      fakeClick: false,
      noMovement: true,
      fakeRenderer: false,
      honeypotFilled: false,
      missingVerifyCookie: false,
      missingVisitorId: false,
      webdriverDetected: false
    }
  };

function isTrustedIp(callback) {
  try {
    fetch('https://api.padronn.com/api/visitor-ip', { cache: 'no-store' })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.ip && config.trustedIps.includes(data.ip)) {
          console.log('[✅ IP Whitelisted]', data.ip);
          callback(true);
        } else {
          callback(false);
        }
      })
      .catch(function (err) {
        console.warn('[⚠️ IP fetch failed]', err);
        callback(false);
      });
  } catch (e) {
    console.warn('[❌ IP check error]', e);
    callback(false);
  }
}


  function insertHoneypot() {
    try {
      var honeypot = document.createElement('input');
      honeypot.name = 'company';
      honeypot.type = 'text';
      honeypot.style = 'display:none !important';
      honeypot.autocomplete = 'off';
      honeypot.setAttribute('aria-hidden', 'true');
      honeypot.onchange = function () {
        state.traps.honeypotFilled = true;
        state.suspicionScore++;
        console.warn('[🚨 Honeypot filled]');
      };
      document.body.appendChild(honeypot);
    } catch (_) {}
  }

  function detectWebGL() {
    try {
      var canvas = document.createElement('canvas');
      var gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
      if (!gl) throw new Error('No WebGL context');
      var debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
      var renderer = debugInfo
        ? gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)
        : gl.getParameter(gl.RENDERER);
      if (!renderer || /swiftshader|llvmpipe|mesa/i.test(renderer)) {
        state.traps.fakeRenderer = true;
        state.suspicionScore++;
        console.warn('[⚠️ Suspicious WebGL renderer]', renderer);
      }
    } catch (e) {
      console.warn('[⚠️ WebGL error]', e.message);
    }
  }

  function checkCookieAndFingerprint() {
    try {
      if (!localStorage.getItem(config.localFlag)) {
        state.traps.missingVisitorId = true;
        state.suspicionScore++;
        console.warn('[⚠️ No fingerprint found]');
      }
    } catch (_) {}

    try {
      var cookies = document.cookie.split('; ');
      var found = false;
      for (var i = 0; i < cookies.length; i++) {
        if (cookies[i].indexOf(config.cookieName + '=') === 0) {
          found = true;
          break;
        }
      }
      if (!found) {
        state.traps.missingVerifyCookie = true;
        state.suspicionScore++;
        console.warn('[⚠️ Missing verification cookie]');
      }
    } catch (_) {}

    try {
      if (navigator.webdriver) {
        state.traps.webdriverDetected = true;
        state.suspicionScore++;
        console.warn('[⚠️ Webdriver detected]');
      }
    } catch (_) {}
  }

  function sendReport() {
    if (state.suspicionScore >= config.suspicionThreshold) {
      var payload = {
        reason: state.traps,
        suspicionScore: state.suspicionScore,
        ua: navigator.userAgent,
        referrer: document.referrer,
        path: location.pathname
      };
      try {
        var visitorId = localStorage.getItem(config.localFlag);
        if (visitorId) payload.visitorId = visitorId;
      } catch (_) {}

      try {
        navigator.sendBeacon(
          config.reportEndpoint,
          new Blob([JSON.stringify(payload)], { type: 'application/json' })
        );
        console.warn('[📡 Suspicious behavior reported]');
      } catch (_) {}
    }
  }

  function graceLogic() {
    if (state.isMobile && config.allowGraceOnMobile && state.suspicionScore <= 1) {
      state.suspicionScore = 0;
      console.log('[ℹ️ Grace applied on mobile]');
    }
  }

  function runTraps() {
    insertHoneypot();
    detectWebGL();

    setTimeout(function () {
      checkCookieAndFingerprint();
      if (state.traps.noMovement && !state.isMobile) {
        state.suspicionScore++;
        console.warn('[⚠️ No movement detected]');
      }
      graceLogic();
      sendReport();
    }, config.delayBeforeCheckMs);
  }

function waitForVerification() {
  if (window.vdgVerified === true) {
    runTraps();
  } else {
    isTrustedIp(function (trusted) {
      if (trusted) {
        window.vdgVerified = true;
        window.vdgWhitelisted = true;
        runTraps();
      } else {
        setTimeout(waitForVerification, 200);
      }
    });
  }
}


  window.addEventListener('mousemove', function () {
    state.traps.noMovement = false;
  });

  document.addEventListener('click', function (e) {
    if (!e.isTrusted || (e.clientX === 0 && e.clientY === 0)) {
      state.traps.fakeClick = true;
      state.suspicionScore++;
      console.warn('[🚨 Fake click detected]');
    }
  });

  if (document.readyState === 'complete') {
    waitForVerification();
  } else {
    window.addEventListener('load', waitForVerification);
  }
})();